/*
 Minimal New Measurement page
*/
import { useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { MenuItem } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useNavigate } from "react-router-dom";
import CrudService from "services/cruds-service";

const numberOrEmpty = (val) => (val === "" ? "" : Number(val));

export default function NewMeasurement() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    weight: "",
    wrist: "",
    arms: "",
    chest: "",
    waist: "",
    hips: "",
    neck: "",
    thighs: "",
    unit: "cm",
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "unit") return setForm((s) => ({ ...s, unit: value }));
    setForm((s) => ({ ...s, [name]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        data: {
          type: "measurements",
          attributes: {
            weight: numberOrEmpty(form.weight),
            wrist: numberOrEmpty(form.wrist),
            arms: numberOrEmpty(form.arms),
            chest: numberOrEmpty(form.chest),
            waist: numberOrEmpty(form.waist),
            hips: numberOrEmpty(form.hips),
            neck: numberOrEmpty(form.neck),
            thighs: numberOrEmpty(form.thighs),
            unit: form.unit,
          },
        },
      };
      await CrudService.createMeasurement(payload);
      navigate("/examples-api/measurement-management", { state: { value: true, text: "Measurement created" } });
    } catch (err) {
      console.error(err);
      setError(err?.errors?.[0]?.detail || "Failed to create measurement");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9} component="form" onSubmit={submit}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <MDBox mt={6} mb={3} textAlign="center">
              <MDTypography variant="h3" fontWeight="bold">Add Measurement</MDTypography>
              <MDTypography variant="h6" color="secondary">Enter body measurements</MDTypography>
            </MDBox>
            <Card>
              <MDBox p={3} display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={2}>
                {[
                  "weight","wrist","arms","chest","waist","hips","neck","thighs"
                ].map((field) => (
                  <MDInput key={field} label={field} name={field} type="number" value={form[field]} onChange={handleChange} />
                ))}
                <MDInput select label="unit" name="unit" value={form.unit} onChange={handleChange}>
                  <MenuItem value="cm">cm</MenuItem>
                  <MenuItem value="in">in</MenuItem>
                </MDInput>
                {error && (
                  <MDTypography variant="caption" color="error">{error}</MDTypography>
                )}
                <MDBox display="flex" justifyContent="flex-end" gridColumn={{ md: "1 / -1" }} mt={2}>
                  <MDButton variant="outlined" color="secondary" sx={{ mr: 1 }} onClick={() => navigate("/examples-api/measurement-management")}>Back</MDButton>
                  <MDButton variant="gradient" color="dark" type="submit">Save</MDButton>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
